import { useShallow } from 'zustand/react/shallow';
import useProductDetailsStore from '../../../stores/ProductDetails/productDetails.store';
import useProductDetailsPreferences from '../../products/products-details-v2/hooks/useProductDetailsPreferences';

type OpenProductDetailsParams = { kitId: string } | { productId: string; productColorId?: string };

const useProductDetailsLauncher = () => {
  const { getProductDetailsPreferences } = useProductDetailsPreferences();
  const [setProductDetailsModalState, handleOpenProductDetailsModal, setFrom] =
    useProductDetailsStore(
      useShallow((state) => [
        state.setProductDetailsModalState,
        state.handleOpenProductDetailsModal,
        state.setFrom,
      ]),
    );

  const openProductDetails = (params: OpenProductDetailsParams) => {
    setFrom(undefined);

    if ('kitId' in params) {
      const preferences = getProductDetailsPreferences();
      setProductDetailsModalState({ isOpen: true, kitId: params.kitId });
      handleOpenProductDetailsModal(
        { orderIds: preferences.orderIds },
        preferences.shouldApplyRelatedProducts,
      );
      return;
    }

    const preferences = getProductDetailsPreferences(params.productColorId);
    setProductDetailsModalState({
      isOpen: true,
      productId: params.productId,
      productColorId: params.productColorId,
    });
    handleOpenProductDetailsModal(
      {
        orderIds: preferences.orderIds,
        productColorId: preferences.productColorId,
        availability: preferences.availability,
        isFinishedOrder: false,
      },
      preferences.shouldApplyRelatedProducts,
    );
  };

  return { openProductDetails };
};

export default useProductDetailsLauncher;
